import { defineMessages } from 'react-intl'

export const GetHelpMessages = defineMessages({
  title: {
    id: 'getHelp.title',
    description: 'Get Help page title',
    defaultMessage: 'Savant Help & Feedback',
  },
})
